var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
export function first(array) {
    return array.length ? array[0] : null;
}
export function last(array) {
    return array.length ? array[array.length - 1] : null;
}
export function flatten(array) {
    return Array.prototype.concat.apply([], array);
}
export function sum(array) {
    return array.reduce(function (s, n) { return s + n; }, 0);
}
export function difference(left, right) {
    var e_1, _a;
    var keys = left.reduce(function (map, key) { return map.add(key); }, new Set());
    try {
        for (var right_1 = __values(right), right_1_1 = right_1.next(); !right_1_1.done; right_1_1 = right_1.next()) {
            var key = right_1_1.value;
            keys.delete(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (right_1_1 && !right_1_1.done && (_a = right_1.return)) _a.call(right_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return Array.from(keys);
}
export function groupBy(keySelector, values) {
    var e_2, _a;
    var groups = new Map();
    try {
        for (var values_1 = __values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
            var value = values_1_1.value;
            var key = keySelector(value);
            if (!groups.has(key)) {
                groups.set(key, []);
            }
            var group = groups.get(key);
            group.push(value);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return groups;
}
